module.exports = __webpack_public_path__ + "media/src/components/library/Loader/img/spinner-pink-aba74d4684c62073c7b7df35843ebc1a.gif";